class ReferralShareWidget extends HTMLElement {
  static TRANSLATIONS = {
    nl: {
      copy: 'Kopieer',
      copied: 'Gekopieerd!',
      error: 'Referral link kon niet worden geladen.',
      email_subject: 'Ontdek PerfecteWijn',
      email_body: 'Ik deel graag PerfecteWijn met je! Gebruik mijn persoonlijke link en ontvang korting op je eerste bestelling: ',
      tweet: 'Ontdek de mooiste wijnen bij @PerfecteWijn! Gebruik mijn link voor korting: '
    },
    en: {
      copy: 'Copy',
      copied: 'Copied!',
      error: 'Referral link could not be loaded.',
      email_subject: 'Discover PerfecteWijn',
      email_body: 'I\'d love to share PerfecteWijn with you! Use my personal link and get a discount on your first order: ',
      tweet: 'Discover the finest wines at @PerfecteWijn! Use my link for a discount: '
    }
  };

  connectedCallback() {
    this.locale = (this.dataset.locale || 'nl').toLowerCase();
    this.t = ReferralShareWidget.TRANSLATIONS[this.locale] || ReferralShareWidget.TRANSLATIONS.nl;

    this.urlInput = this.querySelector('.referral-share__url');
    this.copyBtn = this.querySelector('.referral-share__copy');
    this.fbLink = this.querySelector('.referral-share__social--facebook');
    this.xLink = this.querySelector('.referral-share__social--x');
    this.emailLink = this.querySelector('.referral-share__social--email');

    if (!this.urlInput || !this.copyBtn) return;

    this.copyBtn.addEventListener('click', () => this.copyToClipboard());

    this.waitForSmileSDK()
      .then(() => this.loadReferralUrl())
      .catch(() => this.loadReferralUrl());
  }

  waitForSmileSDK() {
    return new Promise((resolve, reject) => {
      if (window.Smile && typeof Smile.customer !== 'undefined') {
        return resolve();
      }
      let elapsed = 0;
      const interval = setInterval(() => {
        elapsed += 300;
        if (window.Smile && typeof Smile.customer !== 'undefined') {
          clearInterval(interval);
          resolve();
        } else if (elapsed >= 8000) {
          clearInterval(interval);
          reject();
        }
      }, 300);
    });
  }

  async loadReferralUrl() {
    try {
      const result = Smile.customer.current();
      const customer = result && typeof result.then === 'function'
        ? await Promise.race([result, new Promise((_, r) => setTimeout(r, 5000))])
        : result;
      if (customer && customer.referral_url) {
        this.setReferralUrl(customer.referral_url);
        return;
      }
    } catch {
      // SDK not available, referral not enabled, or timeout
    }
    // TODO: Remove preview fallback once Smile referral program is activated
    this.setReferralUrl('https://perfectewijn.nl/?ref=PREVIEW-MODE');
    this.urlInput.style.color = '#999';
  }

  setReferralUrl(url) {
    this.referralUrl = url;
    this.urlInput.value = url;

    if (this.fbLink) {
      this.fbLink.href = 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(url);
    }
    if (this.xLink) {
      this.xLink.href = 'https://twitter.com/intent/tweet?text=' + encodeURIComponent(this.t.tweet + url);
    }
    if (this.emailLink) {
      this.emailLink.href = 'mailto:?subject=' + encodeURIComponent(this.t.email_subject) + '&body=' + encodeURIComponent(this.t.email_body + url);
    }
  }

  async copyToClipboard() {
    if (!this.referralUrl) return;

    try {
      await navigator.clipboard.writeText(this.referralUrl);
    } catch {
      this.urlInput.select();
      document.execCommand('copy');
    }

    const original = this.copyBtn.textContent;
    this.copyBtn.textContent = this.t.copied;
    this.copyBtn.classList.add('referral-share__copy--copied');

    setTimeout(() => {
      this.copyBtn.textContent = original;
      this.copyBtn.classList.remove('referral-share__copy--copied');
    }, 2000);
  }

  showError() {
    this.urlInput.value = '';
    this.urlInput.placeholder = this.t.error;
  }
}

if (!customElements.get('referral-share-widget')) {
  customElements.define('referral-share-widget', ReferralShareWidget);
}
